import {Component, inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {AuthenticationService} from '../../authentication.service';
import {AuthenticationFormFactory} from '../../factories/authentication-form.factory';
import {IconButtonComponent} from '../../../../shared/components/icon-button/icon-button.component';
import {AuthenticationMapper} from '../../mappers/authentication.mapper';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorService} from '../../../../core/services/error.service';

@Component({
  selector: 'app-set-password',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    TextButton,
    TranslocoPipe,
    IconButtonComponent,
    MatDialogClose
  ],
  templateUrl: './set-password.dialog.html',
  styleUrl: './set-password.dialog.scss'
})
export class SetPasswordDialog implements OnInit {
  dialogRef = inject(MatDialogRef<SetPasswordDialog>);
  authenticationService: AuthenticationService = inject(AuthenticationService);
  fb: FormBuilder = inject(FormBuilder);
  translocoService = inject(TranslocoService);
  errorService = inject(ErrorService);

  error?: string;

  setPasswordForm!: FormGroup;

  hidePassword: boolean = true;
  hidePasswordRepeat: boolean = true;

  get isPasswordValid() {
    return this.setPasswordForm.get('password')?.valid || !this.setPasswordForm.get('password')?.touched;
  }

  get isPasswordRepeatValid() {
    return this.setPasswordForm.get('passwordRepeat')?.valid || !this.setPasswordForm.get('passwordRepeat')?.touched;
  }

  get passwordMatch() {
    return this.setPasswordForm.hasError("passwordMatch")
  }

  ngOnInit() {
    this.setPasswordForm = AuthenticationFormFactory.createSetPasswordForm(this.fb);
  }

  setPassword() {
    this.setPasswordForm.markAllAsTouched();
    if (this.setPasswordForm.invalid) {
      return;
    }

    const setPasswordDto = AuthenticationMapper.toSetPasswordDto(this.setPasswordForm.value);
    this.authenticationService.setPassword(setPasswordDto).subscribe({
      next: () => {
        this.error = undefined;
        this.dialogRef.close({success: true});
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 400) {
          this.error = this.translocoService.translate('error.verificationCode');
          return;
        }

        this.error = undefined;
        this.errorService.handleError(error, this.translocoService.translate('error.title.appointments'));
      }
    })
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  togglePasswordRepeatVisibility() {
    this.hidePasswordRepeat = !this.hidePasswordRepeat;
  }
}
